import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import { WindowModule, WINDOW } from '@upr-web-primer/window';
import * as i1 from '@upr-web-primer/storage';
import { get } from 'lodash-es';

class LocaleModule {
}
LocaleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LocaleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleModule, imports: [WindowModule] });
LocaleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleModule, imports: [[WindowModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [WindowModule]
                }]
        }] });

class LocaleService {
    constructor(defaultLanguage, defaultCountry, window, localStorage, sessionStorage) {
        this.defaultLanguage = defaultLanguage;
        this.defaultCountry = defaultCountry;
        this.window = window;
        this.localStorage = localStorage;
        this.sessionStorage = sessionStorage;
    }
    init() {
        const locale = this.getFromUrl();
        this.setStorage(locale);
    }
    getFromUrl() {
        let groups = this.window.location.pathname.match(/(\/[a-zA-Z]{2})+(\/[a-zA-Z]{2})+(\/.*)/i);
        if (!groups) {
            groups = this.window.location.pathname.match(/(\/[a-zA-Z]{2})+(\/[a-zA-Z]{2})+(.*)/i);
        }
        let language = this.defaultLanguage;
        let country = this.defaultCountry;
        if (groups) {
            country = get(groups, '2', country).replace('/', '');
            language = get(groups, '1', language).replace('/', '');
        }
        return {
            country: country,
            language: language
        };
    }
    getFromStorage() {
        return {
            country: this.sessionStorage.getItem('country') ||
                this.localStorage.getItem('country') ||
                this.defaultCountry,
            language: this.sessionStorage.getItem('language') ||
                this.localStorage.getItem('language') ||
                this.defaultLanguage
        };
    }
    setStorage(locale) {
        const language = get(locale, 'language', this.defaultLanguage);
        const country = get(locale, 'country', this.defaultCountry);
        this.sessionStorage.setItem('country', country);
        this.sessionStorage.setItem('language', language);
        this.localStorage.setItem('country', country);
        this.localStorage.setItem('language', language);
    }
}
LocaleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleService, deps: [{ token: 'DefaultLanguage' }, { token: 'DefaultCountry' }, { token: WINDOW }, { token: i1.LocalStorageService }, { token: i1.SessionStorageService }], target: i0.ɵɵFactoryTarget.Injectable });
LocaleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocaleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['DefaultLanguage']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['DefaultCountry']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.LocalStorageService }, { type: i1.SessionStorageService }]; } });

export { LocaleModule, LocaleService };
